import { _plus, _minus } from '@/helpers/bigNumber'

export const type = state => (key) => {
  return state._[key].type
}

export const discountClass = state => (key) => {
  return state._[key].class
}

export const description = state => (key) => {
  return state._[key].description
}

export const amount = state => (key) => {
  return state._[key].amount
}

export const getList = state => {
  return state.list
}

export const getArray = state => {
  return state.list.map(k => {
    return state._[k]
  })
}

export const total = (state, getters) => {
  return state.list.reduce((acc, k) => {
    return getters['type'](k) === '1'
            ? _plus(acc, Number(getters.amount(k)))
            : _minus(acc, Number(getters.amount(k)))
  }, 0)
}

export const apificate = (state, getters) => {
  return state.list.map(k => {
    let other = Object.assign({}, state._[k])
    other.amount = getters['amount'](k)
    return other
  })
}
